var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('article',{staticClass:"bg-w"},_vm._l((_vm.seperate),function(item,name){return _c('report-item',{key:name,attrs:{"item":item,"name":name}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }